module.exports = __webpack_public_path__ + "img/gasbot_eyes_opened.9a4314d3.png";